"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ACTIVITY_DOM_EVENTS = exports.USER_INACTIVE_TIMEOUT = void 0;
exports.USER_INACTIVE_TIMEOUT = 780; // 780 seconds ~ 13 minutes
exports.USER_ACTIVITY_DOM_EVENTS = [
    'mousedown',
    'mousemove',
    'keydown',
    'onclick',
    'scroll',
];
